export default __webpack_public_path__ + "static/media/another.d1c1865a.mp3";